<template>
    <div class="actives">
        <div 
            class="actives-list"
            v-for="item in list"
            :key="item.infoId"
            @click="lookDetail(item)"
        >
            <div class="actives-list__item">{{item.publishDate}}</div>
            <div class="actives-list__info">
                <div class="actives-list__info--title">{{item.title}}</div>
                <div class="actives-list__info--title2" v-if="item.summary" v-html="item.summary"></div>
            </div>
        </div>
        <div class="none-list" v-if="!list.length">抱歉，暂无数据</div>
        <div class="pagination">
            <el-pagination
                :page-size="pageModel.pageSize"
                :current-page="pageModel.page"
                layout="prev, pager, next"
                :total="total"
                :hide-on-single-page="true"
                @current-change="changePage"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: 'list',
    data() {
        return {

        }
    },
    props: {
        list: Array,
        total: {
            type: Number,
            default: 0
        },
        pageModel: {
            type: Object,
            default:() => {
                return {
                    page: 1,
                    pageSize: 20
                }
            }
        },
        fetch: Function
    },
    methods: {
        lookDetail(item) {
            if (item.type == 'PDF') {
                window.open(item.pdf.url)
                return
            }
            this.$router.push({
                name: 'detail',
                params: {
                    id: item.infoId
                }
            })
        },
        changePage(index) {
            this.pageModel.page = index
            this.fetch && this.fetch()
            this.$emit('changePage', index)
        }
    }
}
</script>
<style lang="less">
    .none-list{
        padding: 40px 0;
        text-align: center;
        font-size: 1.4rem;
        color: #999;
    }
    .pagination{
        margin-top: 20px;
        margin-bottom: -10px;
        display: flex;
        justify-content: center;
    }
    .el-pager li.active{
        color: #1E009B;
    }
    .el-pager li:hover{
        color: #1E009B;
    }
    .actives{
        min-height: 300px;
        &-list{
            display: flex;
            border-bottom: 1px solid #ccc;
            box-sizing: border-box;
            padding-top: 25px;
            padding-bottom: 20px;
            cursor: pointer;
            transition: all 0.12s linear;
            &__item{
                flex: 0 0 160px;
                width: 160px;
                color: #838788;
                font-size: 1.4rem;
                margin-top: 4px;
                transition: all 0.12s linear;
            }
            &__info{
                &--title{
                    font-size: 1.8rem;
                    line-height: 25px;
                    color: #838788;
                    transition: all 0.12s linear;
                }
                &--title2{
                    font-size: 1.4rem;
                    color: #666;
                    line-height: 22px;
                    transition: all 0.12s linear;
                    padding-bottom: 15px;
                }
            }
            &:hover{
                border-bottom: 1px solid #1E009B;
                .actives-list__item, .actives-list__info--title{
                    color: #1E009B;
                }
            }
        }
    }
</style>